import { SkeletonGrid, SkeletonCardTile } from '../primitives';

// Matches VoicesV2's real voice-card grid (tabs/search/CreateVoiceWidget render outside
// this, so only the grid area itself needs a skeleton).
export default function AIVoicesSkeleton({ cards = 9 }) {
    return (
        <SkeletonGrid cols={3} gap={12}>
            {Array.from({ length: cards }).map((_, i) => (
                <SkeletonCardTile key={i} hasImage={false} lines={2} />
            ))}
        </SkeletonGrid>
    );
}
